export default __webpack_public_path__ + "static/media/calendar-dark.edb8367d.svg";